import   { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";

import { v4 } from "uuid";
import logo from "../../assets/images/logo.png";
import call from "../../assets/images/svg/call.svg";
import closeIcon from "../../assets/images/close.png";
import Navigation from "../Shared/Navigation";
 import { Col } from "react-bootstrap";
import { handleImage } from "../../utils";
import { FormattedMessage } from "react-intl";
import Image from "next/future/image";
 
const Header = ({ initData, companyProfile }) => {
    const { locale, asPath } = useRouter();
    const neededInfo = initData?.socials?.filter((link) =>
        ["phone", "email", "location address", "location address_en"]?.includes(
            link?.socialType?.name?.en
        )
    );

    const [pdfUrl, setPdfUrl] = useState(companyProfile || null);

    const socials = initData?.socials?.filter(
        (link) =>
            ![
                "phone",
                "email",
                "location address",
                "location address_en",
                "working hours",
                "working hours",
            ]?.includes(link?.socialType?.name?.en)
    );

    const toggleNav = () => {
        document.querySelector(".nav-sidebar").classList.add("active");
        document.querySelector("html").classList.add("off");
    };

    const closeNav = () => {
        document.querySelector(".nav-sidebar").classList.remove("active");
        document.querySelector("html").classList.remove("off");
    };

    useEffect(() => {
        const body = document.body;
        const scrollUp = "scroll-up";
        const scrollDown = "scroll-down";
        let lastScroll = 0;

        window.addEventListener("scroll", () => {
            const currentScroll = window.pageYOffset;
            if (currentScroll <= 0) {
                body.classList.remove(scrollUp);
                return;
            }

            if (
                currentScroll > lastScroll &&
                !body.classList.contains(scrollDown)
            ) {
                body.classList.remove(scrollUp);
                body.classList.add(scrollDown);
            } else if (
                currentScroll < lastScroll &&
                body.classList.contains(scrollDown)
            ) {
                body.classList.remove(scrollDown);
                body.classList.add(scrollUp);
            }
            lastScroll = currentScroll;
        });
    }, []);

    const renderProjects = initData?.projects?.map((category) => {
        if (category?.projects?.length > 6) return;
        return category?.projects?.map((project) => {
            return (
                <Col xl={4} lg={4} md={4} sm={6} xs={6} key={project.id}>
                    <Link href={`/projects/${project.slug}`}>
                        <a onClick={closeNav}>
                            <Image
                                src={`${process.env.NEXT_PUBLIC_MAIN_URL}${project?.mainImage}`}
                                width={194}
                                height={154}
                                alt=""
                               
                                loading="lazy"
                            />
                        </a>
                    </Link>
                </Col>
            );
        });
    });

    // scroll check
    useEffect(() => {
        const body = document.body;
        const scrollUp = "scroll-up";
        const scrollDown = "scroll-down";

        let lastScroll = 0;

        const handleScroll = () => {
            const currentScroll = window.pageYOffset;
            const isHomePage = asPath === "/" || asPath === "/ar"; // account for ar homepage

            // Scroll direction logic
            if (currentScroll <= 0) {
                body.classList.remove(scrollUp);
            }

            if (
                currentScroll > lastScroll &&
                !body.classList.contains(scrollDown)
            ) {
                body.classList.remove(scrollUp);
                body.classList.add(scrollDown);
            } else if (
                currentScroll < lastScroll &&
                body.classList.contains(scrollDown)
            ) {
                body.classList.remove(scrollDown);
                body.classList.add(scrollUp);
            }

            // Header transparency logic
            const header = document.querySelector(".main-head");
            if (!header) return;

            if (isHomePage && currentScroll <= 0) {
                header.classList.add("transparent-header");
                header.classList.remove("solid-header");
            } else {
                header.classList.remove("transparent-header");
                header.classList.add("solid-header");
            }

            lastScroll = currentScroll;
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); // initial check

        return () => window.removeEventListener("scroll", handleScroll);
    }, [asPath]);

    return (
        <>
            <header className="main-head">
                <div className="head-inner">
                    <div className="logo">
                        <Link href="/">
                            <a>
                                <div className="logo-descktop">
                                    <Image
                                        src={
                                            handleImage(
                                                initData?.siteInfo?.appLogo?.[
                                                    locale
                                                ]
                                            ) || logo.src
                                        }
                                        width={200}
                                        height={100}
                                        alt="logo"
                                        loading="lazy"
                                    />
                                </div>
                            </a>
                        </Link>
                    </div>
                    <Navigation />
                    <div className="extra-actions">
                        <div className="lang">
                            <ul>
                                <li className="menu-item-has-children">
                                    <span>
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M8.92478 0.53125C4.10837 0.53125 0.206026 4.46875 0.206026 9.25C0.206026 14.0664 4.10837 17.9688 8.92478 17.9688C13.706 17.9688 17.6435 14.0664 17.6435 9.25C17.6435 4.46875 13.706 0.53125 8.92478 0.53125ZM8.5029 9.00391C8.39743 9.17969 8.22165 9.25 8.01071 9.25C7.87009 9.25 7.72946 9.32031 7.62399 9.42578L7.41306 9.63672C7.30759 9.74219 7.30759 9.91797 7.41306 10.0234L7.62399 10.2344C7.72946 10.3398 7.79978 10.4805 7.79978 10.6211V10.9375C7.79978 11.2539 7.51853 11.5 7.23728 11.5H6.99118C6.78024 11.5 6.60446 11.3945 6.49899 11.2188L5.6904 9.60156C5.62009 9.46094 5.40915 9.39062 5.26853 9.53125L4.5654 10.2344C4.45993 10.3398 4.31931 10.375 4.17868 10.375H1.96384C1.92868 10.0234 1.89353 9.63672 1.89353 9.25C1.89353 5.38281 5.02243 2.21875 8.92478 2.21875C9.66306 2.21875 10.4013 2.35938 11.0693 2.57031L9.31149 3.94141C9.13571 4.04688 9.13571 4.32812 9.34665 4.43359L9.73337 4.60938C9.90915 4.71484 10.0498 4.89062 10.0498 5.10156V7.84375C10.0498 8.01953 9.90915 8.125 9.76853 8.125H9.6279C9.52243 8.125 9.45212 8.08984 9.38181 7.98438C9.34665 7.87891 9.17087 7.87891 9.13571 7.98438L8.5029 9.00391ZM14.5498 12.8711C14.5498 13.0117 14.4795 13.1523 14.374 13.2578L14.0224 13.6094C13.917 13.7148 13.7763 13.75 13.6357 13.75H13.1084C12.9677 13.75 12.792 13.7148 12.6865 13.6094L12.2295 13.1523C12.0888 12.9766 11.8427 12.8711 11.5967 12.8711C11.4912 12.8711 11.4209 12.8711 11.3506 12.9062L10.6123 13.082C10.542 13.082 10.5068 13.1172 10.4717 13.1172H10.1201C9.94431 13.1172 9.80368 13.0469 9.69821 12.9414L9.27634 12.5195C9.24118 12.4844 9.20603 12.4141 9.20603 12.3086V11.957C9.20603 11.8516 9.27634 11.7461 9.38181 11.7109L10.7529 11.1484C10.8232 11.1133 10.8935 11.0781 10.9638 11.043L11.8076 10.4453C11.8427 10.4102 11.9131 10.4102 11.9482 10.4102H12.3701C12.5107 10.4102 12.6162 10.4453 12.6513 10.5508L12.8271 11.0078C12.8623 11.0781 12.8974 11.1133 12.9677 11.1133H13.1084C13.1435 11.1133 13.2138 11.0781 13.2138 11.0078L13.3896 10.4805C13.3896 10.4453 13.4599 10.4102 13.4951 10.4102H13.7412C13.8115 10.4102 13.8818 10.4453 13.8818 10.5508V10.9727C13.8818 11.0781 13.8818 11.1484 13.9521 11.1836L14.374 11.6055C14.4795 11.7109 14.5146 11.8516 14.5146 11.9922V12.8711H14.5498Z"
                                                fill="#8C8C8C"
                                            />
                                        </svg>
                                        {locale == "ar" ? "AR" : "EN"}
                                    </span>
                                    <ul className="sub-menu">
                                        <li>
                                            <Link
                                                href={asPath}
                                                locale="ar"
                                                passHref
                                            >
                                                <a>AR</a>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                href={asPath}
                                                locale="en"
                                                passHref
                                            >
                                                <a>EN</a>
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        {pdfUrl ? (
                            <a
                                href={`${process.env.NEXT_PUBLIC_MAIN_URL}/${pdfUrl?.url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn"
                                download
                            >
                                <FormattedMessage id="downloadProfile" />
                            </a>
                        ) : (
                            <button className="btn" disabled>
                                <FormattedMessage id="downloadProfile" />
                            </button>
                        )}
                        <div className="call-wrp">
                            <div className="c-icon">
                                <Image
                                    src={call.src}
                                    width={16}
                                    height={16}
                                    alt=""
                                     loading="lazy"
                                />
                            </div>
                            <div className="c-data">
                                <p>
                                    <FormattedMessage id="phone" />
                                </p>
                                <Link
                                    href={`tel:${
                                        neededInfo?.filter(
                                            (link) =>
                                                link?.socialType?.name?.en ===
                                                "phone"
                                        )[0]?.link
                                    }`}
                                >
                                    <a>
                                        {
                                            neededInfo?.filter(
                                                (link) =>
                                                    link?.socialType?.name
                                                        ?.en === "phone"
                                            )[0]?.link
                                        }
                                    </a>
                                </Link>
                            </div>
                        </div>
                        <button onClick={toggleNav} className="op-sidebar" aria-label="toggle nav bar">
                            <span></span>
                            <span></span>
                        </button>
                    </div>
                </div>
            </header>
            <div className="nav-sidebar">
                <div className="inner">
                    <button onClick={closeNav} aria-label="close nav bar">
                        <Image
                            src={closeIcon.src}
                            width={27}
                            height={27}
                            alt=""
                          
                            loading="lazy"
                        />
                    </button>
                    <div className="s-logo">
                        <Link href="/">
                            <a aria-label="logo link">
                                <Image
                                    src={handleImage(
                                        initData?.siteInfo?.appLogo?.[locale]
                                    )} 
                                    width={200}
                                    height={200}
                                    alt=""
                                   
                                    loading="lazy"
                                />
                            </a>
                        </Link>
                    </div>
                    <div className="s-nav">
                        <Navigation />
                    </div>
                    
                    <div className="s-info">
                        
                        <ul>
                            <li>
                                <span>
                                    <FormattedMessage id="phone" /> :{" "}
                                </span>
                                <Link
                                    href={`tel:${
                                        neededInfo?.filter(
                                            (link) =>
                                                link?.socialType?.name?.en ===
                                                "phone"
                                        )[0]?.link
                                    }`}
                                >
                                    <a>
                                        {
                                            neededInfo?.filter(
                                                (link) =>
                                                    link?.socialType?.name
                                                        ?.en === "phone"
                                            )[0]?.link
                                        }
                                    </a>
                                </Link>
                            </li>
                            <li>
                                <span>
                                    <FormattedMessage id="email" /> :{" "}
                                </span>
                                <Link
                                    href={`mailto:${
                                        neededInfo?.filter(
                                            (link) =>
                                                link?.socialType?.name?.en ===
                                                "email"
                                        )[0]?.link
                                    }`}
                                >
                                    <a>
                                        {
                                            neededInfo?.filter(
                                                (link) =>
                                                    link?.socialType?.name
                                                        ?.en === "email"
                                            )[0]?.link
                                        }
                                    </a>
                                </Link>
                            </li>
                            <li>
                                <span>
                                    <FormattedMessage id="address" /> :{" "}
                                </span>
                                {
                                    neededInfo?.filter(
                                        (link) =>
                                            link?.socialType?.name?.en ===
                                            `location address${
                                                locale === "ar" ? "" : "_en"
                                            }`
                                    )[0]?.link
                                }
                            </li>
                        </ul>
                    </div>
                    <div className="s-socials">
                        <h4>
                            <FormattedMessage id="contactVia" /> :
                        </h4>
                        <div className="social">
                            {socials?.map((social) => (
                                <Link href={social?.link} key={v4()}>
                                    <a target={"_blank"} aria-label={`social-${social?.socialType?.name.en}`}>
                                        <Image
                                            src={`${process.env.NEXT_PUBLIC_MAIN_URL}${social?.socialType?.icon}`}
                                            width={15}
                                            height={15}
                                            alt=""
                                             loading="lazy"
                                        />
                                    </a>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;
